import { PhaseDefinition, PromotionDetail } from 'types/FutureInvestment';
import { getQuarter } from 'date-fns';

const phaseTemplate: PhaseDefinition[] = [
  {
    title: 'Adquisición', subtitle: 'Activo adquirido', boolKey: 'adquisicion', dateKey: 'trimestreAdquisicion',
  },
  {
    title: 'Licencia y financiación', subtitle: 'Listo para iniciar la obra', boolKey: 'licenciaFinanciacion', dateKey: 'trimestreLicenciaFinanciacion',
  },
  {
    title: 'Obra', subtitle: 'Trabajos en curso', boolKey: 'obra', dateKey: 'trimestreObra',
  },
  {
    title: 'LPO', subtitle: 'Licencia de Primera Ocupación', boolKey: 'lpo', dateKey: 'trimestreLPO',
  },
  {
    title: 'Explotación', subtitle: 'Puesta en carga del Operador', boolKey: 'explotacion', dateKey: 'trimestreExplotacion',
  },
  {
    title: 'Desinversión', subtitle: 'Desinversión completada', boolKey: 'desinversion', dateKey: 'trimestreDesinversion',
  },
  {
    title: 'Entrega de viviendas', subtitle: 'Viviendas entregadas', boolKey: 'entregaViviendas', dateKey: 'trimestreEntrega',
  },
  {
    title: 'Finalizado', subtitle: 'Proyecto finalizado', boolKey: 'finalizado', dateKey: 'trimestreFinalizacion',
  },
];
type HorizontalTimelineProps = {
  steps: Array<{
    header: string;
    title: string;
    subtitle: string;
    progress?: number;
  }>;
};

function generateProgressData( promotion: PromotionDetail | null ) {
  if ( !promotion ) return [];

  return phaseTemplate.reduce( ( acc, phase ) => {
    const isComplete = promotion[phase.boolKey] === true;
    const rawDate = promotion[phase.dateKey];

    if ( !rawDate || typeof rawDate !== 'string' || rawDate.trim() === '' ) {
      return acc; // Ignorar si no hay fecha válida
    }

    const date = new Date( rawDate );
    if ( Number.isNaN( date.getTime() ) ) {
      return acc; // Ignorar si no es una fecha válida
    }

    const quarter = getQuarter( date );
    const year = date.getFullYear();
    const header = `Q${quarter} - ${year}`;

    acc.push( {
      header,
      title: phase.title,
      subtitle: phase.subtitle,
      progress: isComplete ? 100 : 0,
    } );

    return acc;
  }, [] as HorizontalTimelineProps['steps'] );
}

export {
  generateProgressData,
  phaseTemplate,
};
